import React, { useEffect, useState } from "react";
import { Card, CardContent, Hidden} from "@material-ui/core";
import { Grid ,Typography,Box} from "@material-ui/core";
import { makeStyles} from "@material-ui/styles";
import { useSelector } from "react-redux";
import { commonService } from "../../../../services/common.service";
import { store } from "../../../../helpers";
import { usageService } from "../service/e_service";


const useStyles = makeStyles((theme) => ({
    rightCardColor: {
        backgroundColor: theme.palette.ePrimary?.base,
      },
      leftMiddleColor: {
        backgroundColor: theme.palette.eSecondary?.hover,
      },
      rightMiddleColor: {
        backgroundColor: theme.palette.eTertiary?.base,
      },
      leftCardColor: {
        backgroundColor: theme.palette.ePastelColor1?.base,
      },
      boxColor:{
        backgroundColor: theme.palette.ePastelColor2?.base,
        padding:"1%",
      },
      gridPadding:{
        marginTop:10,
        marginBottom:10,
      },
    title:{
        marginBottom:20,
        marginTop:20,
        marginLeft:10,
        marginRight:10,
        fontSize:"0.75rem",
        color: theme.palette.ePrimary?.base
    },
    leftTitle:{
            marginBottom:20,
            marginTop:20,
            marginLeft:10,
            marginRight:10,
            fontSize:"0.875rem",
            color: theme.palette.eWhite?.base
    },
    perYear:{
        fontSize:"0.5625rem",
        color: theme.palette.eWhite?.base
    },
    border:{
        marginBottom:10,
        marginTop:10,
        marginLeft:8,
        marginRight:28,
        color: theme.palette.ePrimary?.base,
    },
    estimatedCost:{
        fontSize:"0.625rem",
    },
    save:{
        fontSize:"0.875rem",
        color: theme.palette.eWhite?.base
    },
    bestBorder:{
        marginBottom:10,
        marginTop:10,
        marginLeft:30,
        marginRight:10,
        fontSize:"0.75rem",
        color : theme.palette.eWhite?.base
    },
    image:{
        marginLeft:25,   
        marginRight:5, 
        bottom: "0",
        width: "10vh",
        height  : "9vh",
    },
    white:{
        color: theme.palette.eWhite?.base
    }
  }));
  function prepareArrayData(allData){
    let arrayData=[];
    let tempArray;
    allData && arrayData.push(allData);
    if(arrayData){
        allData && allData.rates.map((item)=>{
            if(item.isLowestCostRatePlan === "true"){
                tempArray = item
            }
          })
    }
    return tempArray
  }

export default function E_RateSimulator(props){
    const EnergyPlanclasses = useStyles();
    const curlSymbol = useSelector((state) =>state?.meterDetails?.curSymbol);
    const [newEnergyRateImagePath, setNewEnergyRateImagePath] = useState("");
    const [currentRateImagePath, setCurrentRateImagePath] = useState("");
    let newEnergyRateImage = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.E_SUSTAINABILITY_MAN_CARD_IMAGE
      );
    let currentRateImage = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.E_SUSTAINABILITY_ELECTRIC_IMAGE
      );
      useEffect(() => {
        if (currentRateImage) {
          commonService.getAssestUrl(currentRateImage).then((response) => {
            setCurrentRateImagePath(response);
        })
    }
        if (newEnergyRateImage) {
            commonService.getAssestUrl(newEnergyRateImage).then((response) => {
              setNewEnergyRateImagePath(response);
          })
      }
    },[currentRateImage,newEnergyRateImage])
    const [error,setError] = useState(false);
    const [rightSideCardData, setRightSideCardData] = useState()
    let EnergyPlansLabels = useSelector(
        (state) => state?.labels?.data?.getLabels?.E_SUSTAINABILITY
      );
      const [data,setData] = useState();
      const accountId = useSelector((state) => state?.meterDetails?.accountId);
      let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
      useEffect(()=>{
        store.getState().snackbar = true;
         if(accountId && saId){
            usageService.getEnergyPlansDetails(saId, accountId)
            .then((response) => {
               store.getState().snackbar = false;
               setData(response?.data?.getEnergyPlans)
               setRightSideCardData(prepareArrayData(response?.data?.getEnergyPlans))
               setError(false)
            })
            .catch((err) =>{
                setError(true);
            });
         }
      },[saId, accountId])
      const [allPlansData,setAllPlansData]=useState()
      const [space,setSpace]=useState()
      useEffect(()=>{
          setAllPlansData(data);
          setSpace(" ")
      },[data])
      const [value, setValue] = React.useState(props.rateToCompare);
    const [higherPlans,setHigherPlans] = useState()
      if(value?.rateSchedule !== props.rateToCompare?.rateSchedule){
        setValue(props.rateToCompare);
      }    
    useEffect(() => {     
            setRightSideCardData(value); 
            setHigherPlans(value?.isLowCostPlan)      
    }, [value]);
      
    return(   
              <CardContent className={EnergyPlanclasses.boxColor} >
                    <Grid container direction="column" justifyContent="center" alignItems="center" className={EnergyPlanclasses.gridPadding}>
                   <Grid Item xs={12} >
                       <Box display="flex" justifyContent="center" alignItems="center">
                    <Card  className={EnergyPlanclasses.leftCardColor}>   
                        <Typography
                            className={EnergyPlanclasses.title}   
                            align="center">
                            <b>{EnergyPlansLabels?.E_YOUR_CURRENT_RATE}</b>
                        </Typography>
                            <Typography align="center" 
                                     className={EnergyPlanclasses.leftMiddleColor}> 
                                        <Typography className={EnergyPlanclasses.white}
                                            align="center"><br></br>
                                            <b>{allPlansData?.rateScheduleDescription}</b>
                                        </Typography>
                                        <Typography container direction="column" 
                                        align="left"  className={EnergyPlanclasses.bestBorder}>
                                            <span>
                                            <b>{EnergyPlansLabels?.E_BEST_FOR} :</b>{space}{allPlansData?.bestFor}<br></br></span>
                                            <span>
                                            <b>{EnergyPlansLabels?.E_PRICE_HIGHEST} :</b>{space}{allPlansData?.priceHighest}
                                            </span>
                                        </Typography>
                                        <br></br>
                            </Typography>
                            <br></br>
                            <Grid container direction="row" alignItems="center">  
                            <Grid item xs={12} md={12} lg={12} >
                                            <Box display="flex"
                                                justifyContent="center"
                                                alignItems="center">

                            {currentRateImagePath && (
                                    <img 
                                         className={EnergyPlanclasses.image}
                                        src={currentRateImagePath?.assetPath}
                                        alt={EnergyPlansLabels?.[currentRateImagePath?.fallBackLabelKey]}
                                    />
                                    )}
                        <Grid item direction="column" xs={12}>      
                        <Typography variant="subtitle2"
                                        align="left">
                                        <span className={EnergyPlanclasses.border}><b>{curlSymbol}{allPlansData?.calculatedAmount}</b></span>    
                        </Typography>
                        <Typography xs={3} align="left" className={EnergyPlanclasses.estimatedCost}>
                            <span className={EnergyPlanclasses.border}><b>{EnergyPlansLabels?.E_ESTIMATED}</b></span>
                        </Typography> 
                        </Grid>  
                        </Box>
                        </Grid>  
            </Grid>
        </Card>
                 
                    <Card className={EnergyPlanclasses.rightCardColor}>
                        <Typography
                            className={EnergyPlanclasses.leftTitle}    
                            align="center">
                            <b>{EnergyPlansLabels?.E_YOUR_NEW_ENERGY_RATE_PLAN}</b>
                        </Typography>
                        <Typography container direction="column" 
                        align="center">
                            {higherPlans === "false" ? (<b className={EnergyPlanclasses.save}>{EnergyPlansLabels?.E_RATE_IMPACT}</b>) : (<b className={EnergyPlanclasses.save}>{EnergyPlansLabels?.E_SAVE}</b>)}{space}                           
                            <b className={EnergyPlanclasses.save}>{curlSymbol}{Math.abs(rightSideCardData?.differenceAmount)}</b>{space}<span className={EnergyPlanclasses.perYear}><b>{EnergyPlansLabels?.E_PER_YEAR}</b></span>
                        </Typography> 
                        <Grid item md={12} sm={12} >
                            <Grid alignItems="center"  className={EnergyPlanclasses.rightMiddleColor}>
                                        <Typography className={EnergyPlanclasses.leftTitle}
                                            align="center" ><br></br>
                                            <b>{rightSideCardData?.rateScheduleDescription}</b>
                                        </Typography>
                                        <Typography  container direction="column" 
                                        align="left" className={EnergyPlanclasses.bestBorder}>
                                            <span className={EnergyPlanclasses.white} >
                                            <b>{EnergyPlansLabels?.E_BEST_FOR} :</b>{space}{rightSideCardData?.bestFor}<br></br></span>
                                            <span className={EnergyPlanclasses.white}><b>{EnergyPlansLabels?.E_PRICE_HIGHEST} :</b>{space}{rightSideCardData?.priceHighest}</span>
                                        </Typography>
                                        <br></br>
                            </Grid>
                        </Grid>
                        <br></br>
                        <Grid container direction="row" alignItems="center">
                        <Grid item xs={12} md={12} lg={12} >   
                            <Box display="flex"
                                justifyContent="center"
                                alignItems="center">                        
                            {newEnergyRateImagePath && (
                                    <img
                                         className={EnergyPlanclasses.image}
                                        src={newEnergyRateImagePath?.assetPath}
                                        alt={EnergyPlansLabels?.[newEnergyRateImagePath?.fallBackLabelKey]}
                                    />
                                    )}                      
                        <Grid container direction="column"> 
                                <Typography  variant="subtitle2"
                                                align="left">
                                                    <span className={EnergyPlanclasses.border}>
                                                    <b className={EnergyPlanclasses.white}>{curlSymbol}{rightSideCardData?.calculatedAmount}</b></span>
                                </Typography>
                                <Typography align="left" className={EnergyPlanclasses.estimatedCost} >
                                    <span className={EnergyPlanclasses.border}><b className={EnergyPlanclasses.white}>{EnergyPlansLabels?.E_ESTIMATED}</b></span>   
                                </Typography>
                        </Grid>  
                        </Box>
                        </Grid>
                    </Grid> 
                    </Card>
                    </Box>
                    </Grid>
                    </Grid>
              </CardContent>
    );
}